import React from 'react'

export const available = ({ gov_person_registrations }) => (
  !(gov_person_registrations || []).some(({ details }) => (
    details
    && details.Current === 'Y'
    && details.Relationship === 'Additional Educator'
  ))
)

// eslint-disable-next-line react/display-name
const registerEducatorForm = ({ first_name }) => () => (
  <fieldset>
    Register {first_name} as an additional educator.
  </fieldset>
)


const apiEndPoint = ({ gov_registration, personnel }) => (
  process.env.REACT_APP_API_HOST +
  `/api/gov-registrations/${gov_registration.gov_id}/personnel/${personnel.id}/educator-registration`
)

export const registerEducator = ({ gov_registration, personnel }) => (
  available(gov_registration) ?
    {
      label: 'Register as Additional Educator',
      value: 'register_additional_educator',
      component: registerEducatorForm(personnel),
      url: apiEndPoint({ gov_registration, personnel })
    } :
    null
)


// WEBPACK FOOTER //
// ./src/personnel/details/register-educator/index.js